// Import modules the entire application uses.
import _ from 'lodash'
import Popper from 'popper.js'
import $ from 'jquery'
import 'bootstrap'

// Import the customized datatables
// See https://datatables.net/download/#bs4/dt-1.10.23/b-1.6.5/sc-2.0.3/sl-1.3.1
import 'datatables.net-bs4'
import 'datatables.net-buttons/js/buttons.colVis'
import 'datatables.net-buttons-bs4'
import 'datatables.net-colreorder-bs4'
import 'datatables.net-scroller-bs4'
import 'datatables.net-select-bs4'

/**
 * Expose the global modules on window.
 */
window._ = _
window.Popper = Popper
window.$ = window.jQuery = $

// Import plugin modules that modify the globals
import 'jquery-datetimepicker/build/jquery.datetimepicker.full.js'
//import 'bootstrap-datepicker'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// window.axios = require('axios')
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js')

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// })
